import React from "react";
import { connect } from "dva"
import { framework_tool, component_tool, utils_tool } from "@/tool"

import moment from "moment";

import SurveyTempFileImport from "./surveyTempFileImport"
import SurveyRecordInfoDetail from "./surveyRecordInfoDetail"

let { WizContainer, modelUtils } = framework_tool
let { WizSpin, WizButton,  WizTabs,  WizModal,  WizCard,WizDataTable, WizBrowserExport } = component_tool
let { TabPane } = WizTabs
let { getPageData, Session } = utils_tool;


let exportColums =(self,info,surveyInfo) => {
  let columnDefs = []
  columnDefs = [
    {
      headerName: '',
      width: 30,
      field: 'rowIndex',
      hidden: true,
      suppressMovable: true,
      cellStyle: {
        textAlign: 'center',
        padding: '5px 0',
        color: '#595959',
        backgroundColor: '#f0f0f0',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '500',
        boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
      }
    },
    {
      headerName: '账号',
      field: 'lmsUserName',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '姓名',
      field: 'lmsFullName',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '问卷提交时间',
      field: 'submissionDate',
      width: 30,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      }
    }
  ]

  let leng = 0
  let questions = []
  if (info && info.length) {
    for (let i = 0;i< info.length; i++) {
      let iLen = info[i]['questions'].length
      for (let j = 0; j < info.length - i; j++) {
        let jLen = info[j]['questions'].length
        if (jLen > iLen) {
          leng = jLen
        } else {
          leng = iLen
        }
      }
    }

    info.forEach(e => {
      if (e['questions'] && e['questions'].length && e['questions'].length === leng) {
        questions = e['questions']
      }
    })
  }

  if (questions && questions.length === 0 ) {
    questions = surveyInfo && surveyInfo.questions
  }

  if(questions && questions.length) {
    questions.forEach(e => {
      columnDefs.push({
        headerName: e['title'],
        field: e['title'],
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        }
      })
    })
  }
  return columnDefs
}

 /**获取表格的内容*/
 let getTableData=(data)=>{
  let dataInfo = []
  if (data && data.length) {
    dataInfo = data
    dataInfo.forEach(e => {
      if (e['disabled'] === 0) {
        e['disabled'] = "激活"
      } else {
        e['disabled'] = "禁用"
      }
      if (e['userType'] === 0) {
        e['userType'] = "学员"
      } else if (e['userType'] === 1) {
        e['userType'] = "SGM总部"
      } else if (e['userType'] === 2) {
        e['userType'] = "SGM区域"
      } else if (e['userType'] === 3) {
        e['userType'] = "供应商"
      } else {
        e['userType'] = ""
      }
      if (e['questions'] && e['questions'].length) {
        e['questions'].forEach(q => {
          let answerOptions = []
          let title = new Set();
          if (q['answerOptions'] && q['answerOptions'].length) {
            answerOptions = q['answerOptions']
            answerOptions.forEach(a => {
              if (a['content']) {
                title.add(a['content'])
              }
            })
          } else {
            if (q['answer']) {
              title.add(q['answer'])
            }
          }
          if (q['otherAnswer'] && q['otherAnswer'].length) {
            title.add(q['otherAnswer'])
          }
          e[q['title']] = Array.from(title).toString();
        })
      }
    })
  }
  return dataInfo;
}


const surveyInfoColumns =(self) => {
  let columns = []
  columns = columns.concat([
    {
      title: "问卷名称",
      name: "title",
      searchItem: {},
      tableItem: {
      }
    },
    {
      title: "开始时间",
      name: "startDate",
      tableItem: {
        width: 180,
        render: (text, record) => {
          const { startDate } = record;
          return formatterDate(startDate);
        }
      }
    },
    {
      title: "结束时间",
      name: "endDate",
      tableItem: {
        width: 180,
        render: (text, record) => {
          const { endDate } = record;
          return formatterDate(endDate);
        }
      }
    },
    {
      title: "操作",
      tableItem: {
        fixed: 'right',
        width: 200,
        render: (text, record) => {
          let r = [
            <WizButton tooltip="导出问卷记录" onClick={e => {self._exportSurveyRecord(record)}}>导出问卷记录</WizButton>
          ]
          return (
            <>
            <WizDataTable.Oper>
              {r}
            </WizDataTable.Oper>
              </>
          )
        }
      }
    }
  ])
  return columns;
}

const surveyTempColumns =(self) => {
  let columns = []
  columns = columns.concat([
    {
      title: "模版名称",
      name: "surveyTempName",
      searchItem: {},
      tableItem: {
      }
    },
    {
      title: "导入人",
      name: "creatorName",
      tableItem: {
      }
    },
    {
      title: "导入时间",
      name: "createTime",
      tableItem: {
        width: 180,
        render: (text, record) => {
          const { createTime } = record;
          return formatterDate(createTime);
        }
      }
    },
    {
      title: "操作",
      tableItem: {
        fixed: 'right',
        width: 200,
        render: (text, record) => {
          let {id,state,personId,surveyTempName,surveyTempId} = record
          let onClickPreview =()=>{
            self.setState({
              surveyPreviewVisible:true,
              surveyInfo:record
            })
          }
          let onClickDelete =()=>{
            const content = '您确定删除[' + surveyTempName + ']吗?'
            WizModal.confirm({
              title: '注意', content,
              onOk: () => {
                self._deleteSurveyTemp(id,surveyTempId)
              },
              onCancel() { }
            });
          }
          let onClickDownload =()=>{
            self.downloadFile(record)
          }
          let r = [
            <WizButton tooltip="删除" onClick={e => {onClickDelete()}}>删除</WizButton>,
           // <WizButton tooltip="预览" onClick={e => {onClickPreview()}}>预览</WizButton>,
            <WizButton tooltip="下载" onClick={e => {onClickDownload()}}>下载</WizButton>
          ]
          return (
            <>
            <WizDataTable.Oper>
              {r}
            </WizDataTable.Oper>
              </>
          )
        }
      }
    }
  ])
  return columns;
}

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY.MM.DD HH:mm') : '';
}

class SurveyInfoList extends WizContainer {
  componentName = 'interactLive'

  constructor(props) {
    super(props);
    const { record } = props;
    this.liveInfo = record
    this.state = {
      surveyActivityKey: "1",
      time: new Date().getTime(),
      searchParams : {interactLiveId:this.liveInfo.id,type:1},
      surveyImport:false,
      surveyPreviewVisible:false,
      surveyInfo:{}
    }
  }

  _componentDidMount() {
    this._getSurveyInfoList({interactLiveId: this.liveInfo.id });
  }

  _getSurveyInfoList(apiParams = {}) {
    this.doAction(
      {
        path: 'interactLiveSurveyTemp/getSurveyInfoList',
        payload: {
          key: 'interactLiveSurveyTemp@getSurveyInfoList',
          apiParams: {
            ...apiParams,
            meetingNo:this.liveInfo.ownerId
          }
        }
      }
    )
  }

  _getSurveyTempList(apiParams = {}) {
    this.doAction(
      {
        path: 'interactLiveSurveyTemp/list',
        payload: {
          key: 'interactLiveSurveyTemp@list',
          apiParams: {
            ...apiParams,
            interactLiveId:this.liveInfo.id
          }
        }
      }
    )
  }

  _exportSurveyRecord(apiParams = {}) {
    this.doAction(
      {
        path: 'interactLiveSurveyTemp/getSurveyRecordList',
        payload: {
          key: 'interactLiveSurveyTemp@getSurveyRecordList',
          apiParams: {
            //...apiParams
            surveyId: apiParams.id
          }
        }
      }
    )
  }

  _deleteSurveyTemp(id,surveyTempId) {
    this.doAction(
      {
        path: 'interactLiveSurveyTemp/delete',
        payload: {
          key: 'interactLiveSurveyTemp@delete',
          apiParams: {
            id,
            surveyTempId
          }
        }
      }
    )
  }

  getBlob(url, cb) {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = function () {
      if (xhr.status === 200) {
        cb(xhr.response);
      }
    };
    xhr.send();
  }
  
  saveAs(blob, filename) {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      let link = document.createElement('a');
      let body = document.querySelector('body');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      // fix Firefox
      link.style.display = 'none';
      body.appendChild(link);
      link.click();
      body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    };
  }

  downloadFile(data) {
    console.log("data==",data)
    let {surveyTempName,fileId} = data
    let fileName= surveyTempName+ ".xlsx"
    if (fileId) {
      let url = getOssFilePath(fileId)
      this.getBlob(url, (blob) => {
        this.saveAs(blob, fileName);
      });
    }
   // this.props.changeModal(false);
  }

  propsAndStateOnChange = {
    getSurveyRecordList : this._getSurveyRecordListOver.bind(this),
    deleteRe : this._handleCMD.bind(this)
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps["deleteRe"]
    if (o['success']) {
      wizNotice.success(o['msg'])
      this._getSurveyTempList();
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
 

   /**获取导出数据*/
   _getSurveyRecordListOver(nextProps, nextState) {
    //let { surveyInfo } = nextState
    if (nextProps.getSurveyRecordList.code === 1) {
      let data = nextProps.getSurveyRecordList.data
      let columnDefs = exportColums(this, data, data[0])
      let title = data[0] && data[0].title ? data[0].title : "问卷记录信息"
      let dataInfo = getTableData(data)
      WizBrowserExport({
        title: title,
        sheetName: '问卷记录信息',
        columns: columnDefs.filter((_, index) => index),
        rows: dataInfo,
        filename: '问卷记录信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  changeTab = (e) => {
    let searchParams = {};
    if (e === "1") {
      searchParams = {interactLiveId: this.liveInfo.id }
      this._getSurveyInfoList(searchParams)
    } else if (e === "2") {
      searchParams = {interactLiveId: this.liveInfo.id }
      this._getSurveyTempList(searchParams)
    }
    this.setState({
      time: new Date().getTime(),
      surveyActivityKey: e,
      searchParams:searchParams
    })
  }

  renderRecordList = () => {
    let { getSurveyInfoList, interactLiveSurveyTempList, interactLiveSurveyTempLoading } = this.props;
    let tableKey = this.state.surveyActivityKey;
    let columns;
    let pageList;
    let loading = interactLiveSurveyTempLoading;
    switch(tableKey){
      case "1": 
       columns = surveyInfoColumns(this)
       pageList = getPageData({records:getSurveyInfoList && getSurveyInfoList.data})
        break;
        case "2": 
       columns = surveyTempColumns(this)
       pageList = getPageData({records:interactLiveSurveyTempList && interactLiveSurveyTempList.data})
        break;
    }
    
    let dataTableProps = {
      loading: loading ,
      columns,
      rowKey: "id",
      dataItems: pageList,
      showNum: false,
      isScroll: true,
      bordered: true,
      onChange: ({ pageNum, pageSize }) => {
        values = { current: pageNum, size: pageSize, ...this.state.searchParams}
        if(tableKey=='1'){
          this._getSurveyInfoList(values)
        }else if(tableKey=='2'){
          this._getSurveyTempList(values)
        }
      },
    }
    return (
      <WizSpin key={'tab_' + tableKey} tip={'加载中'} spinning={false }>
         {this.getBtn()}
        <WizDataTable key={'record_dataTable'} {...dataTableProps} />
      </WizSpin>
    )
  }

  getBtn() {
    let btnList = [];
    switch(this.state.surveyActivityKey){
      case "2" : btnList = [
        <WizButton onClick={ ()=> {this.setState({surveyImport:true})} }>导入模版</WizButton>,
      ]
      break;
    }
    let btnsR = <WizButton.WizGroup>
      {btnList}
    </WizButton.WizGroup>
    return btnsR;
  }

  onCloseModal=()=>{
    this.setState({surveyImport: false});
    this._getSurveyTempList()
  }

  _render() {
    return (
      <>
        <WizCard >
          <WizTabs activeKey={this.state.surveyActivityKey} animated={false} onChange={this.changeTab}>
            <TabPane tab="问卷记录" key="1">
              {this.renderRecordList()}
            </TabPane>
            <TabPane tab="问卷模版" key="2">
              {this.renderRecordList()}
            </TabPane>
          </WizTabs>
        </WizCard>
        <WizModal destroyOnClose
                  key={"surveyTempImport"+new Date().getTime()}
                  width={700} title={"导入模版"}
                  visible={this.state.surveyImport}
                  footer={null}
                  onOk={() => {
                    this.setState({surveyImport: false})
                  }}
                  onCancel={() => {
                    this.setState({surveyImport: false})
                  }}
        >
          <SurveyTempFileImport record={this.liveInfo} onCloseModal={()=>this.onCloseModal()}/>
        </WizModal>

        <WizModal destroyOnClose
                  key={new Date().getTime()}
                  width={700} title={"查看问卷"}
                  visible={this.state.surveyPreviewVisible}
                  footer={null}
                  onOk={() => {
                    this.setState({surveyPreviewVisible: false})
                  }}
                  onCancel={() => {
                    this.setState({surveyPreviewVisible: false})
                  }}
        >
          <SurveyRecordInfoDetail record={this.state.surveyInfo}/>
        </WizModal>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { interactLiveSurveyTemp} = state
  const { history } = ownProps
  const getSurveyInfoList = modelUtils.getModelEntity(interactLiveSurveyTemp, "interactLiveSurveyTemp@getSurveyInfoList")
  const interactLiveSurveyTempList = modelUtils.getModelEntity(interactLiveSurveyTemp, "interactLiveSurveyTemp@list")
  const getSurveyRecordList = modelUtils.getModelEntity(interactLiveSurveyTemp, "interactLiveSurveyTemp@getSurveyRecordList")
  const deleteRe = modelUtils.getModelEntity(interactLiveSurveyTemp, "interactLiveSurveyTemp@delete")
  const load = modelUtils.getLoadingState(state, ['interactLiveSurveyTemp']);
  return {
    getSurveyInfoList,
    interactLiveSurveyTempList,
    getSurveyRecordList,
    deleteRe,
    ...load
  }
}

export default connect(mapStateToProps)(SurveyInfoList)
